import { defineStore } from 'pinia'
export interface LoadingState {
  status: string
}

export const useLoadingStore = defineStore('useLoadingStore', {
  state: (): LoadingState => {
    return {
      status: '',
    }
  },
  actions: {
    start() {
      this.status = 'start'
    },
    completed() {
      this.status = 'completed'
    },
  },
})
